import { Apollo } from 'apollo-angular';
import { Component, Inject, LOCALE_ID } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { SystemPage, SystemPageResponse } from 'src/app/apollo/models/base-models';
import { SYSTEM_PAGE_CONTENT_QUERY } from 'src/app/apollo/static-page';
import { BasePageComponent } from '../../base-page/base-page.component';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ChangePasswordService } from 'src/app/services/auth/change-password/change-password.service';
import { ChangePasswordResponse } from 'src/app/services/auth/change-password/change-password.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends BasePageComponent {

  page: SystemPage;
  body: SafeHtml;
  formSubmited: boolean = false;
  errorMsg: string;
  hasError: boolean = false;
  hideOldPassword = true;
  hideNewPassword = true;
  hideRepeatPassword = true;
  isSuccess: boolean;

  changePasswordResponse: ChangePasswordResponse;


  changePasswordForm = this.formBuilder.group({
    old_password: ['', [Validators.required, Validators.minLength(7)]],
    new_password: ['', [Validators.required, Validators.minLength(7)]],
    new_password_repeat: ['', [Validators.required, Validators.minLength(7)]],
  });

  constructor(private apollo: Apollo,
    private formBuilder: UntypedFormBuilder,
    private detectDeviceService: DetectDeviceService,
    private changePasswordService: ChangePasswordService,
    protected licenceService: LicenceService,
    @Inject(LOCALE_ID) public locale: string,
    private sanitizer: DomSanitizer,) { super() }

  ngOnInit(): void {
    this.isDesktop = this.detectDeviceService.isDesktop();
    this.apollo.watchQuery<SystemPageResponse>({
      query: SYSTEM_PAGE_CONTENT_QUERY,
      variables: {
        pageName: "change-password",
        locale: this.locale
      }
    }).valueChanges.pipe(takeUntil(this.unsubscribe),).subscribe((resp) => {
      this.page = resp.data.systemPage;
      this.body = this.sanitizer.bypassSecurityTrustHtml(this.page.content.html);
    }, (error) => {

    });
  }

  onSubmit(changePasswordForm) {
    if (this.formSubmited) return;
    this.errorMsg = null;
    this.formSubmited = true;
    this.changePasswordService.requestChangePassword(changePasswordForm).pipe(takeUntil(this.unsubscribe)).subscribe((resp: ChangePasswordResponse) => {
      this.changePasswordResponse = resp;
      this.isSuccess = true;
    }, err => {
      this.formSubmited = false;
      if (err.status === 406) {
        this.errorMsg = err.error.error_message;
        this.hasError = true;
        console.log(this.errorMsg);
      }
    });
  }

}
